import "@hotwired/turbo";
import { debugError } from "./utils";
import { Application } from "@hotwired/stimulus";
import controllers from "./controllers-index.js"
import "./welcomeBottomsheet.js";
import toast from "./utils/toast";
import { translateError } from "./errorTranslations.js";
import { handleFrameMissing } from "./utils/frameMissing.mjs";

document.addEventListener("turbo:frame-missing", (event) =>
  handleFrameMissing(event, {
    toast: (message) => toast(message, "error"),
    translate: translateError,
    visit: (url, options) => window.Turbo.visit(url, options),
  }),
);

// Early PWA install prompt capture
window._pwaDeferredPrompt = null;

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window._pwaDeferredPrompt = e;
});

window.Stimulus = Application.start();
window.Stimulus.state = {};

Stimulus.debug = process.env.PARCEL_DEBUG_MODE;

for (const { name, controller } of controllers) {
  const cleanName = name
    .replace("Controller", "")
    .replace(/_/g, "-");

  const identifier = toIdentifier(cleanName);
  Stimulus.register(identifier, controller);
}

Stimulus.handleError = (error, message, detail) => {
  debugError(message, detail, error);
};

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
navigator.serviceWorker.register(new URL('./service-worker.js', import.meta.url))
      .then((reg) => console.log('Service Worker registered:', reg.scope))
      .catch((err) => console.error('Service Worker registration failed:', err));
  });
}

function toIdentifier(segment) {
    return segment
      .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
      .replace(/([A-Z])([A-Z][a-z])/g, "$1-$2")
      .replace(/_/g, "-")
      .toLowerCase();
}
